import React from 'react'
import './projects.css';

import image from '../Myimages/project\.png'
import Insta from '../Myimages/Insta project clone.png'
import Todo from '../Myimages/todo.png'

export default function projects() {
  return (
    <div className='  text-white h-auto pb-12'>
        <div className='flex flex-wrap  py-16'>
           <h2 className='main-heading text-4xl font-bold p-6 px-32'>
              Projects
           </h2>
        </div>
        <div className='projects grid grid-cols-3 px-48 gap-20 '>
           <div className='main-box bg-[var(--card-bg)] p-8 w-96 h-auto leading-normal '>
              <div>
                 <img className='w-full h-auto' src={image} alt="project image" />
              </div>
              <div className='flex flex-wrap py-3' >
                 <h2 className='text-2xl font-bold py-4 '>
                 Job Application
                 </h2>
                 <p className='text-lg tracking-tight' >
                    I built a Job Application System where users can browse job listings, apply for positions, and track their application status. The system includes features like user authentication, job posting, and an admin dashboard for managing applications.
                 </p>
              </div>
              <div className='pt-24 flex flex-wrap justify-around'>
                 <button className='text-xl font-semibold bg-[var(--bg-header)] hover:bg-[var(--hover-text)] w-20 h-12 rounded-3xl '>Demo</button>
                 <button className='text-xl font-semibold bg-[var(--bg-header)] hover:bg-[var(--hover-text)] w-36 h-12 rounded-3xl '>Source Code</button>
              </div>
             
           </div>
           <div className='main-box bg-[var(--card-bg)] p-8 w-96 h-auto leading-normal '>
              <div>
                 <img className='w-full h-64' src={Insta} alt="project image" />
              </div>
              <div className='flex flex-wrap py-3' >
                 <h2 className='text-2xl font-bold py-4 '>
                  Instagram Clone
                 </h2>
                 <p className='text-lg tracking-tight' >
                    Built a responsive Instagram Clone using React.js, featuring user authentication, image uploads, real-time post feed, likes, and comments. Integrated Firebase for backend services including Auth, Firestore database, and Cloud Storage. Designed with a mobile-first UI for a smooth user experience.
                 </p>
              </div>
              <div className='pt-14 flex flex-wrap justify-around'>
                 <button className='text-xl font-semibold bg-[var(--bg-header)]  hover:bg-[var(--hover-text)] w-20 h-12 rounded-3xl '>Demo</button>
                 <button className='text-xl font-semibold bg-[var(--bg-header)] hover:bg-[var(--hover-text)] w-36 h-12 rounded-3xl '>Source Code</button>
              </div>
             
           </div>
           <div className='main-box bg-[var(--card-bg)] p-8 w-96 h-auto leading-normal '>
              <div>
                 <img className='w-full h-64' src={Todo} alt="project image" />
              </div>
              <div className='flex flex-wrap py-3' >
                 <h2 className='text-2xl font-bold py-4 '>
                 Todo List
                 </h2>
                 <p className='text-lg tracking-tight' >
                    Developed a simple and interactive Todo List app using React.js. Features include adding, editing, deleting, and marking tasks as complete. Utilized React Hooks for state management and implemented a clean, responsive UI.


                 </p>
              </div>
              <div className='pt-28 flex flex-wrap justify-around'>
                 <button className=' text-xl font-semibold bg-[var(--bg-header)]  hover:bg-[var(--hover-text)] w-20 h-12 rounded-3xl '>Demo</button>
                 <button className=' text-xl font-semibold bg-[var(--bg-header)]  hover:bg-[var(--hover-text)] w-36 h-12 rounded-3xl '>Source Code</button>
              </div>
             
           </div>
           
        </div>
    </div>
  )
}
